import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M2.909 6.609a3.7 3.7 0 0 1 3.7-3.7h6.782a3.7 3.7 0 0 1 3.7 3.7v6.782a3.7 3.7 0 0 1-3.7 3.7H6.61a3.7 3.7 0 0 1-3.7-3.7zm1.455-.505h11.272A2.3 2.3 0 0 0 13.39 4.31H6.61a2.3 2.3 0 0 0-2.245 1.795m11.327 1.4H4.31v5.887a2.3 2.3 0 0 0 2.3 2.3h6.782a2.3 2.3 0 0 0 2.3-2.3z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            d="M7.69 13.08a.77.77 0 1 1-1.54 0 .77.77 0 0 1 1.54 0m3.08 0a.77.77 0 1 1-1.54 0 .77.77 0 0 1 1.54 0m0-3.08a.77.77 0 1 1-1.54 0 .77.77 0 0 1 1.54 0m3.08 0a.77.77 0 1 1-1.54 0 .77.77 0 0 1 1.54 0"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
